module.exports = __webpack_public_path__ + "img/c07_unitmerchanttransport_Normal_ua.a11bf5cd.webp";